import * as React from 'react';

export default function JobTags({ blok }) {
  if (!blok.job_tags) {
    return null;
  }
  const tags = blok.job_tags.split(',');

  return (
    <div
      className="flex gap-4 mb-8 text-white mt-[60px] lg:mt-[100px] px-4 lg:px-16 overflow-x-auto pb-2"
      key={`job-tags-${blok._uid}`}
    >
      {tags.map((tag) => (
        <div key={tag} className="bg-green-900 p-2 text-xs lg:text-base whitespace-nowrap">
          {tag.trim()}
        </div>
      ))}

    </div>
  );
}
